import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Goals from "@/pages/Goals";
import Sessions from "@/pages/Sessions";
import Readiness from "@/pages/Readiness";
import Rankings from "@/pages/Rankings";
import Assessments from "@/pages/Assessments";
import Team from "@/pages/Team";
import LowPerformers from "@/pages/LowPerformers";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, authChecked } = useApp();
  if (!authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B1120] text-slate-400">
        <div className="animate-pulse font-display tracking-widest text-sm uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/readiness" element={<Readiness />} />
        <Route path="/rankings" element={<Rankings />} />
        <Route path="/assessments" element={<Assessments />} />
        <Route path="/team" element={<Team />} />
        <Route path="/low-performers" element={<LowPerformers />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App noise-bg">
      <BrowserRouter>
        <AppProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
